// extracted by mini-css-extract-plugin
module.exports = {"info":"src-components-AccountsTab-Analytics-module__info--2gP6v"};